module.exports = __webpack_public_path__ + "static/media/Diaz.bfdef0b6.jpg";